import type { ApiEmbedSearchWidgetId } from 'api/types/ApiTypedId';
import { FetchEndpoint } from 'utils/endpoint/FetchEndpoint';

import type { ApiEmbedSearchWidget } from './types/ApiEmbedSearchWidget';

type ApiResponse = {
  embedSearchWidget: ApiEmbedSearchWidget;
};

function mapResponse(response: ApiResponse) {
  return response.embedSearchWidget;
}

const endpoint = new FetchEndpoint({
  urlFactory: (embedSearchWidgetId: ApiEmbedSearchWidgetId) =>
    `/data/website/embed-search-widgets/${embedSearchWidgetId}`,
  mapResponse,
});

// Exports

export const apiHorizonFetchEmbedSearchWidget =
  endpoint.createIsomorphicFetchFn();
